import { effect } from "../fmt";
import { Effect } from "./Effect";
import type { Ruleset, UpgradeProfileData } from "./Ruleset";

export class UpgradeProfile {
  ruleset: Ruleset;
  data: UpgradeProfileData;

  constructor(ruleset: Ruleset, data: UpgradeProfileData) {
    this.ruleset = ruleset;
    this.data = data;
  }

  get id() {
    return this.data.id;
  }

  get name() {
    return this.data.name;
  }

  get type() {
    return this.data.type;
  }

  get effects() {
    return (
      this.data.effects?.map((data) => Effect.from(this.ruleset, data)) ?? []
    );
  }

  get summary() {
    return this.effects.map(effect).join(" ");
  }
}
